import { PrefixUrl } from 'common/constants/prefix-url';
import { defaultUrl } from 'hooks/use-ky';
import React from 'react';

export default function PrefixUrlChanger() {
  const onChangeUrl = React.useCallback(() => {
    const url = prompt('Enter Staging Url:', PrefixUrl.get());
    if (url) {
      PrefixUrl.set(url);
      window.location.reload();
    }
  }, []);
  if (defaultUrl.includes('staging')) {
    return (
      <div
        style={{
          position: 'fixed',
          bottom: 8,
          right: 8,
          opacity: 0.2,
          zIndex: 12,
          cursor: 'pointer',
        }}
        onClick={onChangeUrl}
      >
        <span>staging mode</span>
      </div>
    );
  }
  return null;
}
